/**
 * Feedback visual de "añadido al carrito" en el icono de compra rápida de la
 * tarjeta de producto (kaninor-product-card.liquid).
 *
 * product-form.js quita la clase .loading en cuanto responde el fetch —éxito
 * o error—, así que el aro rojo de kaninor-product-card.css solo se ve una
 * fracción de segundo y, mientras dura, el icono queda en opacity:0: se
 * siente como que el botón se vacía en vez de confirmar nada. Aquí se marca
 * el botón como --added justo cuando se confirma el éxito (evento global
 * cart-update, que product-form.js solo publica si el fetch fue bien) y se
 * queda así un momento con un check en vez de la bolsa.
 *
 * Solo cubre el caso de una variante (el botón hace type="submit" directo):
 * con varias variantes el flujo pasa por el modal de elegir opción, que ya
 * se cierra solo al añadir y da su propio feedback.
 */
(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  var ADDED_CLASS = 'kaninor-card__quick-add-button--added';
  var ADDED_DURATION_MS = 1600;
  var pendingButton = null;

  document.addEventListener(
    'submit',
    function (event) {
      var button = event.target.querySelector('.kaninor-card__quick-add-button[type="submit"]');
      if (button) pendingButton = button;
    },
    true
  );

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
    if (!pendingButton || (data && data.source !== 'product-form')) return;

    var button = pendingButton;
    pendingButton = null;

    button.classList.add(ADDED_CLASS);
    window.setTimeout(function () {
      button.classList.remove(ADDED_CLASS);
    }, ADDED_DURATION_MS);
  });
})();
